<template>
  <vs-button
    :color="activeLink ? 'success' : 'success'"
    :type="activeLink ? 'filled' : 'border'"
    icon-pack="feather"
    :icon="icon"
    :size="size"
    @click="navigate">
    {{ title }}
  </vs-button>
</template>

<script>
export default {
  name: 'MyAccountUserNavButton',
  props: {
    route: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    icon: {
      type: String
    },
    size: {
      type: String,
      default: 'small'
    }
  },
  computed: {
    currentRoute () {
      return this.$store.getters.currentRoute
    },
    activeLink () {
      return this.currentRoute.name && this.currentRoute.name.includes(this.route)
    }
  },
  methods: {
    navigate () {
      if (!this.activeLink) {
        this.$router.push({ name: this.route })
      }
    }
  }
}
</script>

<style scoped>

</style>
